var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sm-error-block"},[_c('h4',{staticClass:"sm-txt-center"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))]),_vm._t("content"),_c('btn-block',{attrs:{"text":_vm.btnText},on:{"click":function($event){return _vm.$emit('close')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }